export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5558.ea38fda7.jpg";